module.exports = __webpack_public_path__ + "img/status_approving.c6f9e3df.png";